import { get, post } from '../../helpers/api';

export const POS_SERVICE_URI = '/pos';
export const POS_BASE_URI = '/api/v1/enroll';

export const enrollBankCardAtPos = (bankCard) =>
  post(`${POS_SERVICE_URI}${POS_BASE_URI}/bank-card`, bankCard);

export const getEnrolledBankProduct = (physicalId, action) =>
  get(
    `${POS_SERVICE_URI}${POS_BASE_URI}/bank-card/${physicalId}/physical/${action}`,
  );
